export const REMOVE = 'BUILDER_REMOVE'
export const CREATE = 'BUILDER_CREATE'
export const UPDATE = 'BUILDER_UPDATE'
export const MOVE = 'BUILDER_MOVE'
